<template>
  <sf-banner-inline
    v-tooltip="
      I18n.t('pulse.pending_changes_tooltip', {
        count: templatesWithSubmittedProposalsCount,
      })
    "
    icon-class="icon-edit"
    :variant="bannerVariants.neutral"
    :title="I18n.t('pulse.pending_changes')"
  >
    <template #actions>
      <SfButtonInverted :small="true" variant="dark" @click="openModal">{{
        I18n.t('pulse.accept_all_changes')
      }}</SfButtonInverted>
    </template>
  </sf-banner-inline>
</template>
<script setup lang="ts">
import SfBannerInline from '@app/shared/vue/components/sf-banner/sf-banner-inline.vue'
import { bannerVariants } from '@app/shared/types/banner'
import { SfButtonInverted } from '@app/shared/vue/components/sf-button'

interface Props {
  templatesWithSubmittedProposalsCount: number
}

defineProps<Props>()
const I18n = window.I18n

function openModal() {
  window.modalCitizen.openModalPortal('accept-all-pulse-changes-modal')
}
</script>
